<template>
  <v-app-bar :elevation="0" color="background">
    <v-container class="pa-0" fluid>
      <!-- espacio opcional para la búsqueda -->
    </v-container>

    <template v-slot:prepend>
      <v-btn v-if="isMobile" icon @click="toggleDrawer">
        <v-icon>mdi-menu-close</v-icon>
      </v-btn>
    </template>

    <template v-slot:append>
      <v-btn icon="mdi-forum">
        <v-badge color="error" content="2">
          <v-icon>mdi-forum</v-icon>
        </v-badge>
      </v-btn>
      <v-btn icon="mdi-bell-outline">
        <v-badge color="error" content="2">
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>

      <v-chip link pill class="justify-space-between" @click="logout">
        {{ user.name + ' ' + user.last_name || 'Guest' }}
        <v-avatar class="avatar-custom">
          <v-img :src="user.avatar || 'https://cdn.vuetifyjs.com/images/john.png'" />
        </v-avatar>
      </v-chip>
    </template>
  </v-app-bar>
</template>

<script setup>
import { useAuthStore } from '@/store/auth';
import { useRouter } from 'vue-router';
import { useUiStore } from '@/store/ui';
import { useDisplay } from 'vuetify';
import { computed } from 'vue';

const authStore = useAuthStore();
const router = useRouter();
const uiStore = useUiStore();
const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const user = computed(() => authStore.user || {});
const logout = async () => {
  authStore.logout();
  router.push({ name: 'Login' });
};

const toggleDrawer = () => {
  uiStore.drawer = !uiStore.drawer;
};
</script>

<style scoped>
.avatar-custom {
  margin-left: 10px;
}
</style>
